.info {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
}

.warning {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 170, 0, 0.12);
  border: 1px solid rgba(255, 170, 0, 0.35);
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
}

.spinner {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  word-break: break-all;
  text-align: right;
}
